import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FrameComponent from "../components/FrameComponent";
import LoginForm from "../components/LoginForm";
import SignupButton from "../components/SignupButton";
import SocialLogin from "../components/SocialLogin";
import HomeIndicator from "../components/HomeIndicator";

const Login = () => {
  const navigate = useNavigate();

  const onSignupBackgroundClick = useCallback(() => {
    navigate("/31-sign-in1");
  }, [navigate]);

  return (
    <div className="w-full relative bg-light-primary-key-background flex flex-col items-start justify-start gap-[50px] leading-[normal] tracking-[normal]">
      <FrameComponent />
      <section className="flex flex-row items-start justify-start pt-0 px-10 pb-[93px] box-border max-w-full text-left text-21xl text-dark-text font-text-regular-lowercase">
        <div className="flex flex-col items-start justify-start gap-[15px]">
          <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
            Bạn đã trở lại
          </h1>
          <h3 className="m-0 relative text-5xl font-semibold font-[inherit] text-light-text">
            Đăng nhập để tiếp tục!
          </h3>
        </div>
      </section>
      <LoginForm />
      <SignupButton
        onSignupBackgroundClick={onSignupBackgroundClick}
        toTiKhon="Tạo tài khoản"
      />
      <SocialLogin />
      {/* <HomeIndicator
        homeIndicatorBackgroundColor="#fff"
        homeIndicatorMargin="unset"
        homeIndicatorPosition="unset"
        homeIndicatorRight="unset"
        homeIndicatorBottom="unset"
        homeIndicatorLeft="unset"
        homeIndicatorTop="unset"
        homeIndicatorMarginTop="unset"
      /> */}
    </div>
  );
};

export default Login;
